var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V6.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6974 13.25V11.8409H13.1053C13.2928 11.8409 13.6184 12.0535 13.6184 12.5455C13.6184 13.0374 13.2928 13.25 13.1053 13.25H10.6974Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6974 16.1591V14.75H13.7368C13.9244 14.75 14.25 14.9626 14.25 15.4545C14.25 15.9465 13.9244 16.1591 13.7368 16.1591H10.6974Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75H22V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V7.75ZM11.3289 10C11.3289 9.58579 10.9932 9.25 10.5789 9.25C10.1647 9.25 9.82895 9.58579 9.82895 10V10.3409H9C8.58579 10.3409 8.25 10.6767 8.25 11.0909C8.25 11.5051 8.58579 11.8409 9 11.8409H9.19737V16.1591H9C8.58579 16.1591 8.25 16.4949 8.25 16.9091C8.25 17.3233 8.58579 17.6591 9 17.6591H9.82895V18C9.82895 18.4142 10.1647 18.75 10.5789 18.75C10.9932 18.75 11.3289 18.4142 11.3289 18V17.6591H11.4079V18C11.4079 18.4142 11.7437 18.75 12.1579 18.75C12.5721 18.75 12.9079 18.4142 12.9079 18V17.6591H13.7368C14.9445 17.6591 15.75 16.5692 15.75 15.4545C15.75 14.739 15.4181 14.0336 14.8609 13.6203C15.0275 13.2917 15.1184 12.92 15.1184 12.5455C15.1184 11.4308 14.313 10.3409 13.1053 10.3409H12.9079V10C12.9079 9.58579 12.5721 9.25 12.1579 9.25C11.7437 9.25 11.4079 9.58579 11.4079 10V10.3409H11.3289V10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinWebsite);
export default __webpack_public_path__ + "static/media/bitcoin-website.1194155f7916e93d469c89dfcf36757b.svg";
export { ForwardRef as ReactComponent };